import { BASE_ARB_AGREEMENT_PATH, CCB, FEB, FINWISE } from 'helpers/Constants';
import { BASE_BORDER_RADIUS } from 'styles/Base';
import { CLOUD, ERROR, GRAY, PRIMARY_BLUE, SKY } from 'styles/Colors';
import { LargeMobile } from 'styles/MediaQueries';
import { makeStyles } from '@mui/styles';
import { printPage } from 'helpers/Print';
import { useSelector } from 'react-redux';
import BasicModal from 'components/component_lib/BasicModal';
import Box from '@mui/material/Box';
import CtaButton from '@opploans/cta-button-component/CtaButton';
import elecCommContent from 'components/rebrand/elecCommDisclosure/elecCommContent';
import LinkButton from '@opploans/link-button-component/LinkButton';
import Modal from '@mui/material/Modal';
import React, { useEffect, useState } from 'react';
import RebrandDisclosureModal from 'components/rebrand/RebrandDisclosureModal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  [LargeMobile]: {
    maxHeight: '100%',
    padding: '2rem',
    width: '100vw'
  },
  boxShadow: 24,
  padding: 0,
  border: 'none',
  borderRadius: BASE_BORDER_RADIUS,
  p: 4
};

const buttonStyle = {
  backgroundColor: CLOUD,
  color: SKY,
  border: `1px solid ${GRAY}`,
  fontSize: '100%',
  width: '100%',
  '&:active, &:hover': {
    backgroundColor: `${GRAY}!important`
  },
  '&:active:hover, &:active:focus, &:active.focus': {
    '&:enabled': {
      border: `1px solid ${GRAY}`
    }
  }
};
const errorContainerStyle = {
  '.errorElecCommDisclosure': {
    border: `1.5px solid ${ERROR}`,
    color: ERROR,
    '&:active:hover, &:focus': {
      '&:enabled': {
        border: `1px solid ${ERROR}`
      }
    }
  }
};
const headerStyle = {
  padding: '1rem 1rem 1rem 1.25rem',
  fontFamily: 'Arimo',
  fontSize: '14px'
};

const override = {
  zIndex: 999999
};

const useStyles = makeStyles({
  root: {
    padding: 0
  }
});

export default function ElecCommModal(dataAttrs) {
  useEffect(() => {
    if (window.BaseModalManager) {
      // eslint-disable-next-line no-new
      const baseModalManager = new window.BaseModalManager();

      baseModalManager.setupModalEvents(
        window.$('.credit-report-auth-modal'),
        'credit-report-authorization'
      );

      baseModalManager.setupModalEvents(
        window.$('.bank-verification-tos-modal'),
        'bank-verification-tos'
      );
    }
  }, []);
  const [open, setOpen] = useState(false);
  const [arbitrationOpen, setArbitrationOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handlePrint = () => printPage('electronic-disclosure-body');
  const errorElecCommDisclosure = useSelector(
    (state) => state.errors.elecCommDisclosure
  );
  const productOwner = useSelector((state) => state.productOwner);
  const customerState = useSelector((store) => store.state);
  let provider = '';

  switch (productOwner) {
    case FINWISE:
      provider = 'FinWise Bank';
      break;
    case FEB:
      provider = 'First Electronic Bank';
      break;
    case CCB:
      provider = 'CCBank';
      break;
    default:
      break;
  }

  return (
    <div
      css={[
        { padding: '0 1.25rem', borderTop: `1px solid ${PRIMARY_BLUE}` },
        errorContainerStyle,
        override
      ]}
    >
      <ul style={headerStyle}>
        <li id='arbitrationAgreement'>
          The Arbitration Clause provided&nbsp;
          <LinkButton
            lightBackground
            id='arbitrationAgreementLink'
            additionalStyle={{ fontSize: '14px' }}
            onClick={() => setArbitrationOpen(true)}
          >
            here
          </LinkButton>
        </li>
        <li>The Electronic Communications Agreement provided below</li>
      </ul>
      <CtaButton
        additionalStyle={buttonStyle}
        className={errorElecCommDisclosure ? 'errorElecCommDisclosure' : ''}
        id='elecCommModalOpen'
        onClick={handleOpen}
      >
        {errorElecCommDisclosure ? 'Read the agreement' : 'View the agreement'}
      </CtaButton>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
        sx={override}
      >
        <Box sx={style} className={useStyles().root}>
          <RebrandDisclosureModal
            id='elecCommDisclosure'
            header={elecCommContent.header}
            bodyContent={elecCommContent.body(provider)}
            checkboxLabel={elecCommContent.footer}
            name='elecCommDisclosure'
            scrollableAreaHeight='25rem'
            dataAttrs={dataAttrs}
            onClose={handleClose}
            onPrint={handlePrint}
          />
        </Box>
      </Modal>
      <BasicModal
        open={arbitrationOpen}
        headerText='Arbitration Agreement'
        handleClose={() => setArbitrationOpen(false)}
        printId='arbitration-agreement-body'
      >
        <iframe
          title='Arbitration Agreement'
          id='arbitration-agreement-body'
          src={`${BASE_ARB_AGREEMENT_PATH}?${`state=${customerState}&finwise=${
            productOwner === FINWISE
          }&bank=${productOwner}`}`}
        />
      </BasicModal>
    </div>
  );
}
